import React, { useEffect, useRef, useState, useCallback } from 'react';
import { makeStyles } from '@mui/styles';
import { Container, Box, Typography, Avatar, Button, Grid, CircularProgress, Card, Chip, Modal, TextField, Autocomplete } from '@mui/material';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Stack from '@mui/material/Stack';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from '@mui/icons-material/Edit';
import toast from 'react-hot-toast';
import LeadService from '../../core/services/leadsService';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '22px',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    width: '558px',
    height: 'auto',
    overflow: 'auto',
};
const useStyles = makeStyles((theme) => ({
    ISAAgentDetailBio: {
        marginTop: '20px',
        padding: '20px',
        borderRadius: '22px',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        // width: '1250px',
        // overflowY: 'auto',
        [theme.breakpoints.down('md')]: {
            marginTop: '20px',
            padding: '20px',
            borderRadius: '22px',
            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
            // width: '1000px',
        },
    },
}));
const AgentTags = ({ IsaAgentTags, ICAAgentsDetails, getISAAgents, IcaAgentId, IcaAgentTag, IcaGetAgentProfileDetail }) => {
    const classes = useStyles();
    const [openEditChip, setOpenEditChip] = useState(false);
    const [openDialogDelete, setOpenDialogDelete] = useState(false);
    const [openAddChip, setOpenAddChip] = useState(false);
    const [addTag, setAddTag] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedTagId, setSelectedTagId] = useState(null);
    const [editTag, setEditTag] = useState('');
    const [editTagId, setEditTagId] = useState('');
    const [deleteId, setDeleteId] = useState('');
    const [tagId, setTagId] = useState('');
    const [getTags, setGetTags] = useState([]);
    const agent_id = ICAAgentsDetails?.id;

    const handleAddTagChange = (event, newValue) => {
        if (typeof newValue === 'string') {
            setAddTag(newValue); // Update input value for custom input
        } else if (newValue && newValue.inputValue) {
            setAddTag(newValue.inputValue); // Handle creation of a new tag
        } else {
            setAddTag(newValue || ''); // Update with selected value
        }
    };
    const handleCloseAddChip = () => {
        setOpenAddChip(false);
    };
    const handleOpenAddChip = (id) => {
        setSelectedTagId(id); // Store the id of the tag
        setOpenAddChip(true); // Open the modal
    };
    const handleDelete = (id, tag_id) => {
        setOpenDialogDelete(true);
        setDeleteId(id);
        setTagId(tag_id);
    };
    const handleCloseDialog = () => {
        setOpenDialogDelete(false);
    };

    const handleEditClick = (id, tag) => {
        setOpenEditChip(true);
        setEditTag(tag);
        setEditTagId(id);
    };
    const handleCloseEditChip = () => {
        setOpenEditChip(false);
    };
    const handleSaveChange = async () => {
        if (!addTag) {
            return toast.error('Tag is required');
        }
        try {
            setLoading(true);
            const idToSend = agent_id || IcaAgentId;
            const res = await LeadService.AddTag(addTag, idToSend);
            if (res.data.success) {
                toast.success(res.data.message);
                setOpenAddChip(false);
                setAddTag('');
                if (agent_id) {
                    getISAAgents(agent_id);
                }
                if (IcaAgentId) {
                    IcaGetAgentProfileDetail(IcaAgentId);
                }
                getAllTags();
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleEditChange = (event) => {
        setEditTag(event.target.value);
    };
    const handleUpdateChange = async () => {
        if (!editTag) {
            return toast.error('Edit Tag is required');
        }
        try {
            setLoading(true);
            const res = await LeadService.updateTag(editTagId, editTag);
            toast.success(res.data.message);
            getISAAgents(agent_id);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
            setOpenEditChip(false);
        }
    };
    const handleDeleteChange = async () => {
        try {
            setLoading(true);
            const res = await LeadService.DeleteTag(deleteId, tagId);
            toast.success(res.data.message);
            if (agent_id) {
                getISAAgents(agent_id);
            }
            if (IcaAgentId) {
                IcaGetAgentProfileDetail(IcaAgentId);
            }
            await getAllTags();
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
            setOpenDialogDelete(false);
        }
    };

    const getAllTags = async () => {
        try {
            const res = await LeadService.getTags();
            if (res.data.success) {
                const tags = res?.data?.data?.map((item) => item?.tag); // Extracting 'tag' values
                setGetTags(tags || []); // Fallback to an empty array if tags is undefined
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    useEffect(() => {
        getAllTags();
    }, []);

    return (
        <>
            <div>
                <Card sx={{ borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',width:{
                    xs: '100%',
                } }} className={classes.ISAAgentDetailBio}>
                    <Typography style={{ fontWeight: 'bold', fontSize: '18px' }}>Tags</Typography>
                    {/* <Stack direction="row" spacing={1}> */}
                    <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '8px',
                                maxHeight: '150px',
                                overflowY: 'auto',
                                padding: '8px',
                                borderRadius: '4px',
                            }}
                        >
                            <>
                                {IcaAgentTag?.map((tag) => (
                                    <Chip
                                        key={tag?.id || tag}
                                        label={
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <span style={{ fontWeight: 'bold' }}>{tag?.tag}</span>
                                            </div>
                                        }
                                        onDelete={() => handleDelete(tag?.pivot?.user_id, tag?.pivot?.tag_id)}
                                        deleteIcon={<DeleteIcon style={{ color: '#df2a2a' }} />}
                                        color="primary"
                                        variant="outlined"
                                    />
                                ))}

                                {IsaAgentTags?.map((tag) => (
                                    <Chip
                                        key={tag?.id || tag}
                                        label={
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <span style={{ fontWeight: 'bold' }}>{tag?.tag}</span>
                                            </div>
                                        }
                                        onDelete={() => handleDelete(tag?.pivot?.user_id, tag?.pivot?.tag_id)}
                                        deleteIcon={<DeleteIcon style={{ color: '#df2a2a' }} />}
                                        color="secondary"
                                        variant="outlined"
                                    />
                                ))}
                            </>
                        </div>

                        <div>
                            <Button
                                onClick={() => handleOpenAddChip(selectedTagId)}
                                variant="contained"
                                sx={{
                                    cursor: 'pointer',
                                    borderRadius: '12px',
                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                    fontWeight: 'bold',
                                    height: '45px',
                                    width: '200px',
                                    marginTop: '6px',
                                    backgroundColor: '#5379BD',
                                    fontFamily: 'inherit',
                                    color: 'white',
                                }}
                            >
                                ➕ Add
                            </Button>
                        </div>
                    </Box>

                    {/* </Stack> */}
                </Card>
            </div>
            {/* Edit Modal */}
            <Modal open={openEditChip} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: '#fff',
                        padding: '20px',
                        borderRadius: '10px',
                        width: '500px',
                        height: '25%',
                        overflow: 'auto',
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            <span style={{ fontWeight: 'bold' }}>Edit Tag</span>
                        </div>
                        <div>
                            <IconButton onClick={handleCloseEditChip}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '16px',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <TextField
                            value={editTag}
                            onChange={handleEditChange}
                            placeholder="Enter Tag"
                            variant="outlined"
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '12px',
                                },
                                width: '250px',
                            }}
                        />
                        <Button
                            onClick={handleUpdateChange}
                            variant="contained"
                            sx={{
                                cursor: 'pointer',
                                borderRadius: '12px',
                                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                fontWeight: 'bold',
                                height: '40px',
                                width: '250px',
                                marginTop: '6px',
                                background: '#5379BD',
                                fontFamily: 'inherit',
                            }}
                            disabled={loading}
                        >
                            {' '}
                            Update
                            {loading && <CircularProgress size="30px" sx={{ visibility: loading ? '' : 'hidden', color: 'white' }} />}
                        </Button>
                    </Box>
                </div>
            </Modal>

            {/* Add Modal */}
            <Modal open={openAddChip} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: '#fff',
                        padding: '20px',
                        borderRadius: '10px',
                        width: '500px',
                        overflow: 'auto',
                    }}
                    className='modal-resp-settings'
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            <span style={{ fontWeight: 'bold' }}>Add Tag</span>
                        </div>
                        <div>
                            <IconButton onClick={handleCloseAddChip}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '16px',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <Autocomplete
                            value={addTag}
                            onChange={(event, newValue) => handleAddTagChange(event, newValue)}
                            onInputChange={(event, newInputValue) => setAddTag(newInputValue)} // To capture typing
                            options={getTags}
                            filterOptions={(options, params) => {
                                const filtered = options.filter((option) => option.toLowerCase().includes(params.inputValue.toLowerCase()));

                                // Suggest creating a new tag if not found in the list
                                if (params.inputValue !== '' && !filtered.includes(params.inputValue)) {
                                    filtered.push({
                                        inputValue: params.inputValue,
                                        label: `${params.inputValue}`,
                                    });
                                }

                                return filtered;
                            }}
                            getOptionLabel={(option) => (typeof option === 'string' ? option : option.label || '')}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Enter Tag"
                                    variant="outlined"
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                        width: '250px',
                                    }}
                                />
                            )}
                        />
                        <Button
                            onClick={handleSaveChange}
                            variant="contained"
                            sx={{
                                cursor: 'pointer',
                                borderRadius: '12px',
                                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                fontWeight: 'bold',
                                height: '40px',
                                width: '250px',
                                marginTop: '6px',
                                background: '#5379BD',
                                fontFamily: 'inherit',
                            }}
                            disabled={loading}
                        >
                            {' '}
                            Save
                            {loading && <CircularProgress size="30px" sx={{ visibility: loading ? '' : 'hidden', color: 'white' }} />}
                        </Button>
                    </Box>
                </div>
            </Modal>
            {/* Delete Modal */}
            <Modal open={openDialogDelete} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <div style={{ marginTop: '20px', position: 'relative' }}>
                        <Box
                            sx={{
                                display: 'grid',
                                padding: '10px',
                                gap: '10px',
                            }}
                        >
                            <Box style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                                <Box>
                                    <CancelIcon style={{ fontSize: '34px' }} />
                                </Box>
                                <Box style={{ display: 'grid', gap: '10px' }}>
                                    <div>
                                        <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Are you sure you want to delete this tag?</span>
                                    </div>
                                    <div>
                                        <span style={{ fontSize: '16px', color: '#252F46' }}>
                                            This action will delete this tag permanently, and you can not undo this.
                                        </span>
                                    </div>
                                </Box>
                            </Box>
                        </Box>

                        <Box style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                            <Button
                                onClick={handleCloseDialog}
                                style={{
                                    width: '140px',
                                    height: '43px',
                                    backgroundColor: 'white',
                                    fontWeight: '500',
                                    borderRadius: '4px',
                                    border: ' 1px solid #587DBF',
                                    color: '#252F46',
                                    fontSize: '15px',
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleDeleteChange}
                                style={{
                                    width: '140px',
                                    height: '43px',
                                    backgroundColor: '#5379BD',
                                    fontWeight: '500',
                                    borderRadius: '4px',
                                    border: ' 1px solid #587DBF',
                                    color: 'white',
                                    fontSize: '15px',
                                }}
                                disabled={loading}
                            >
                                {loading && <CircularProgress sx={{ visibility: loading ? '' : 'hidden', color: 'white' }} />}
                                {loading ? 'Deleting...' : 'Delete'}
                            </Button>
                        </Box>
                    </div>
                </Box>
            </Modal>
        </>
    );
};

export default AgentTags;
